import "../../../../assets/css/dashboard.css";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { Input, notification, Spin, Button, Form, Modal } from "antd";
import { Controller, useForm } from "react-hook-form";
import {
  _get_profile,
  _update_profile,
  _request_email_change,
  _verify_email_change,
  _resend_email_change_code,
} from "../../../../common/axios_services";
import { useResendTimer } from "../../../../hooks/useResendTimer";
import { fetchData, profileData } from "../../../../slices/profileSlice";
import TopNav from "../../../../components/top-nav";

const UpdateEmailPage = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 18, color: "#fff" }} spin />
  );
  const newAntIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;
  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: "",
      description: message,
      // placement: "bottom-right"
    });
  };

  const [loadingData, setLoadingData] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [currentDispTab, setCurrentDispTab] = useState("profile");
  const [modalDispTab, setModalDispTab] = useState("otp");

  // user data
  const profileInfoUser = useSelector((state) => state.userProfile.dataFetched);
  const profileInfo = useSelector((state) => state);

  // basic profile
  const basicInfoValidator = yup.object().shape({
    firstName: yup.string().required("First name field is required"),
    lastName: yup.string().required("Last name field is required"),
    email: yup
      .string()
      .email("Email address is not valid")
      .required("Email address field is required"),
    phoneNumber: yup.string().required("Phone number is not valid"),
  });
  const {
    handleSubmit: handleBasicInfo,
    control: controlBasicInfo,
    setValue: setBasicInfoValue,
    formState: { errors: basicInfoError },
  } = useForm({
    resolver: yupResolver(basicInfoValidator),
  });

  // fetch user data
  const [VerActivated, setVerActivated] = useState(false);
  const [otp, setOtp] = useState(false);
  const [userGenderOption, setUserGenderOption] = useState("");
  const [userDOB, setUserDOB] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [loadingSpinner, setLoadingSpinner] = useState(true);

  const fetchUser = async () => {
    try {
      const user_profile = await _get_profile();
      dispatch(fetchData(true));
      dispatch(profileData(user_profile?.data?.data));
      setVerActivated(user_profile?.data?.data?.login_2fa);
      setImageUrl(user_profile?.data?.data?.image);

      let userData = user_profile?.data.data;
      setBasicInfoValue("firstName", userData.firstName);
      setBasicInfoValue("lastName", userData.lastName);
      setBasicInfoValue("email", userData.email);
      setBasicInfoValue("phoneNumber", userData.phoneNumber);
      setUserGenderOption(userData.gender ? userData.gender : "");
      setUserDOB(userData.dob ? userData.dob : "2008-02-24");
      setBasicInfoValue("userType", userData.role.user_type);
      setLoadingSpinner(false);
      if (user_profile?.data?.data?.email_otp) {
        setOtp(user_profile?.data?.data?.email_otp);
      }
    } catch (err) {
      setLoadingSpinner(false);
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          Navigate(`/signin`);
        }
        dispatch(profileData(false));
        dispatch(fetchData(false));
      } else {
      }
    }
  };
  useEffect(() => {
    fetchUser();
    // if (searchParams.get('pin')) {
    //     setActiveTabKey('3');
    // }
    // updateCount
  }, []);

  const genderOptions = [
    {
      label: "Male",
      value: "male",
    },
    {
      label: "Female",
      value: "female",
    },
  ];

  const onChangeGenderOption = ({ target: { value } }) => {
    setUserGenderOption(value);
  };

  const onChangeUserDOB = (date, dateString) => {
    setUserDOB(dateString);
  };

  const updateUserInfo = async (e) => {
    setLoadingData(true);
    setErrorMessage("");
    try {
      let { email, firstName, lastName, phoneNumber, ageGroup, userType } = e;
      const data = {
        first_name: firstName,
        last_name: lastName,
        email,
        phone_number: phoneNumber,
        userType: userType,
        gender: userGenderOption,
        dob: "",
        image: "",
        pin: profileInfo.pin,
        age: ageGroup,
      };
      const updateProfile = await _update_profile(data);
      setErrorMessage("");
      openNotificationWithIcon("success", updateProfile?.data?.message);
      Navigate("/settings");
    } catch (err) {
      if (err?.response?.data?.message) {
        if (err?.code === "ERR_NETWORK") {
          setErrorMessage(
            "An error occurred while checking pin. Please check network and try again"
          );
        } else if (err?.response?.data?.message === "Unauthorized") {
          setErrorMessage(
            "User Authorization expired. Please log in to continue"
          );
          Navigate("/signin");
        } else {
          setErrorMessage(
            err?.data?.message.length
              ? err?.data?.message
              : err?.response?.data?.message
          );
        }
      } else {
        setErrorMessage(
          "An error occurred while checking pin. Please try again"
        );
      }
      setLoadingData(false);
    }
  };

  const [emailChangeStep, setEmailChangeStep] = useState("request");
  const [emailChangeLoading, setEmailChangeLoading] = useState(false);
  const [emailChangeVisible, setEmailChangeVisible] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");

  const { timer: resendTimer, startTimer: startResendTimer, stopTimer: stopResendTimer } = useResendTimer(60);

  const emailRequestValidator = yup.object().shape({
    newEmail: yup
      .string()
      .email("Email address is not valid")
      .required("New email is required"),
    confirmEmail: yup
      .string()
      .email("Email address is not valid")
      .required("Confirm email is required"),
    currentPassword: yup.string().required("Current password is required"),
  });

  const {
    handleSubmit: handleEmailRequest,
    control: emailRequestControl,
    formState: { errors: emailRequestError },
  } = useForm({
    resolver: yupResolver(emailRequestValidator),
  });

  const requestEmailChange = async (data) => {
    setEmailChangeLoading(true);
    setErrorMessage("");
    try {
      if (data.newEmail !== data.confirmEmail) {
        setErrorMessage("Emails do not match");
        setEmailChangeLoading(false);
        return;
      }

      const response = await _request_email_change({
        newEmail: data.newEmail,
        confirmEmail: data.confirmEmail,
        currentPassword: data.currentPassword,
      });

      openNotificationWithIcon("success", "Verification code sent to your new email");
      setEmailChangeStep("verify");
      startResendTimer();
      setEmailChangeLoading(false);
    } catch (err) {
      setEmailChangeLoading(false);
      if (err.response?.data?.message === "Unauthorized") {
        Navigate("/signin");
      }
      setErrorMessage(err?.response?.data?.message || err?.message);
      openNotificationWithIcon("error", err?.response?.data?.message || err?.message);
    }
  };

  const verifyEmailChange = async () => {
    setEmailChangeLoading(true);
    setErrorMessage("");
    try {
      const response = await _verify_email_change({
        verificationCode: verificationCode,
      });

      openNotificationWithIcon("success", "Email changed successfully");
      setEmailChangeVisible(false);
      setEmailChangeStep("request");
      setVerificationCode("");
      stopResendTimer();
      setEmailChangeLoading(false);
      Navigate("/settings");
    } catch (err) {
      setEmailChangeLoading(false);
      if (err.response?.data?.message === "Unauthorized") {
        Navigate("/signin");
      }
      setErrorMessage(err?.response?.data?.message || err?.message);
      openNotificationWithIcon("error", err?.response?.data?.message || err?.message);
    }
  };

  // security update
  const [userOTP, setUserOTP] = useState("");
  const [reGen, setReGen] = useState(false);
  const [transCodeDrawer, setTransCodeDrawer] = useState(false);
  const [currentOTPCounter, setCurrentOTPCounter] = useState(0);
  const [currentTransCode, setCurrentTransCode] = useState("");
  const [displayTransCodeModal, setDisplayTransCodeModal] = useState(false);

  const {
    handleSubmit: otpCheckHandleSubmit,
    control: otpCheckControl,
    formState: { errors: otpCheckError },
  } = useForm({
    // resolver: yupResolver(otpCheckValidator)
  });

  const closeTransactionCodeDrawer = () => {
    setTransCodeDrawer(false);
  };

  const controlTransCodeModalDisplay = () =>
    setDisplayTransCodeModal(!displayTransCodeModal);

  // const basicInfoValidator = yup.object().shape({
  //     firstName: yup.string().required('First name field is required'),
  //     lastName: yup.string().required('Last name field is required'),
  //     email: yup.string().email('Email address is not valid').required('Email address field is required'),
  //     phoneNumber: yup.string().required('Phone number is not valid'),
  // })
  const { handleSubmit, control, setValue } = useForm({
    resolver: yupResolver(basicInfoValidator),
  });



  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.addEventListener("load", () => callback(reader.result));
  };

  // verify otp box

  const [pageUserPin, setPageUserPin] = useState("");

  const onChangeOTPInput = (e) => {
    if (pageUserPin.length < 4) {
      setPageUserPin(e);
    }
  };

  const [inputData, setInputData] = useState("");
  const [otpCounter, setOtpCounter] = useState(false);
  const [transPinErrorMessage, setTransPinErrorMessage] = useState("");

  const toggleOTPCounter = () => setOtpCounter(!otpCounter);
  const toggleTransCodeModalDisplay = () => {
    if (pageUserPin.length === 4) {
      setDisplayTransCodeModal(!displayTransCodeModal);
      setOtpCounter(true);
    } else {
      openNotificationWithIcon("error", "Please enter 4 characters");
    }
  };



  return (
    <div>
      <Spin spinning={loadingSpinner} indicator={newAntIcon}>
        <div className="profile-display settings-display form-page">
          <TopNav title="Update Email" />
          <div className="display-main-content white-b">
            <div className="contain">
              <div className="mt_4">
                <div>
                  <div>
                    {errorMessage.length ? (
                      <p className="form-error mb_3">{errorMessage}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt_4 mb_5">
                    <button
                      className="py-3 px-5 w-full font-gilroyBold text-[15px] rounded-xl bg-green-600 text-white hover:bg-green-700"
                      onClick={() => setEmailChangeVisible(true)}
                    >
                      Change Email Address
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          centered={true}
          className="airtimeModal"
          open={emailChangeVisible}
          closable={false}
          maskClosable={false}
          footer={null}
        >
          <div>
            {emailChangeStep === "request" ? (
              <div>
                <h4 className="modal-title">Change Email Address</h4>
                <div style={{ marginTop: "5%" }}></div>
                {errorMessage ? (
                  <p className="error-message">{errorMessage}</p>
                ) : (
                  ""
                )}
                <Form
                  layout="vertical"
                  style={{ maxWidth: 600 }}
                  onFinish={handleEmailRequest(requestEmailChange)}
                  autoComplete="off"
                >
                  <Form.Item label="New Email" name="newEmail">
                    <Controller
                      name="newEmail"
                      control={emailRequestControl}
                      defaultValue=""
                      render={({ field }) => (
                        <Input
                          type="email"
                          {...field}
                          placeholder="Enter new email"
                          disabled={emailChangeLoading}
                        />
                      )}
                    />
                    {emailRequestError.newEmail && (
                      <p className="form-error">{emailRequestError.newEmail.message}</p>
                    )}
                  </Form.Item>

                  <Form.Item label="Confirm Email" name="confirmEmail">
                    <Controller
                      name="confirmEmail"
                      control={emailRequestControl}
                      defaultValue=""
                      render={({ field }) => (
                        <Input
                          type="email"
                          {...field}
                          placeholder="Confirm new email"
                          disabled={emailChangeLoading}
                        />
                      )}
                    />
                    {emailRequestError.confirmEmail && (
                      <p className="form-error">{emailRequestError.confirmEmail.message}</p>
                    )}
                  </Form.Item>

                  <Form.Item label="Current Password" name="currentPassword">
                    <Controller
                      name="currentPassword"
                      control={emailRequestControl}
                      defaultValue=""
                      render={({ field }) => (
                        <Input.Password
                          {...field}
                          placeholder="Enter current password"
                          disabled={emailChangeLoading}
                        />
                      )}
                    />
                    {emailRequestError.currentPassword && (
                      <p className="form-error">{emailRequestError.currentPassword.message}</p>
                    )}
                  </Form.Item>

                  <div className="flex gap-2">
                    <Button
                      type="primary"
                      className="bg-gray-900"
                      htmlType="submit"
                      loading={emailChangeLoading}
                      disabled={emailChangeLoading}
                    >
                      Continue
                    </Button>
                    <Button
                      onClick={() => {
                        setEmailChangeVisible(false);
                        setEmailChangeStep("request");
                        setErrorMessage("");
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </div>
            ) : (
              <div>
                <h4 className="modal-title">Verify Email Change</h4>
                <p className="text-3xl">Enter the verification code sent to your new email.</p>
                <div style={{ marginTop: "5%" }}></div>
                {errorMessage ? (
                  <p className="error-message">{errorMessage}</p>
                ) : (
                  ""
                )}
                <Form layout="vertical" style={{ maxWidth: 600 }}>
                  <Form.Item label="Verification Code" name="verificationCode">
                    <Input
                      type="text"
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value)}
                      placeholder="Enter code"
                      disabled={emailChangeLoading}
                      maxLength={6}
                    />
                  </Form.Item>

                  <div className="flex gap-2">
                    <Button
                      type="primary"
                      className="bg-gray-900"
                      onClick={verifyEmailChange}
                      loading={emailChangeLoading}
                      disabled={emailChangeLoading || !verificationCode}
                    >
                      Verify
                    </Button>
                    <Button
                      type="dashed"
                      disabled={resendTimer > 0 || emailChangeLoading}
                      onClick={async () => {
                        if (resendTimer === 0) {
                          setEmailChangeLoading(true);
                          try {
                            await _resend_email_change_code();
                            openNotificationWithIcon("success", "Verification code sent to your new email");
                            startResendTimer();
                            setVerificationCode("");
                          } catch (err) {
                            openNotificationWithIcon("error", err?.response?.data?.message || "Failed to resend code");
                          } finally {
                            setEmailChangeLoading(false);
                          }
                        }
                      }}
                    >
                      {resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend Code"}
                    </Button>
                    <Button
                      onClick={() => {
                        setEmailChangeVisible(false);
                        setEmailChangeStep("request");
                        setVerificationCode("");
                        stopResendTimer();
                        setErrorMessage("");
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </div>
            )}
          </div>
        </Modal>
      </Spin>
    </div>
  );
};

export default UpdateEmailPage;
